import React from 'react'
import { useTranslation } from 'react-i18next'

import cloneDeep from 'lodash/cloneDeep'

import { Checkbox, Form, Number as NumberInput, Select } from 'components/forms'

import Divider from 'components/Divider'
import printerLocations from 'gql/query/appConfig/printerLocations'
import globalStyles from 'style/app.module.scss'
import { useQuery } from 'components/graphql'
import PrinterRecord from './PrinterRecord'

const PrinterLocation = ({ data, formData, parameters, updateItem, appData }) => {
	const [t] = useTranslation()
	const printerLocationsRes = useQuery(printerLocations, { fetchPolicy: 'cache-first' })
	const locationData = [...(printerLocationsRes.data?.getAppConfig?.cashRegisterGlobal?.printerLocations || [])]
		.sort(({ dbIndex: a }, { dbIndex: b }) => a - b)

	const handleSubmit = vals => {
		const printerVals = cloneDeep(vals)
		const printer = printerVals?.parameters?.printer
		if(printer?.separateKitchenBill && !printer.separateKitchenCourse) {
			printer.separateKitchenCourse = 1
		}
		const locations = printerVals?.parameters?.printer?.locations
		if (locations && Object.keys(locations).length !== 0) {
			let newLocationArr = locations.map((item) => {
				if(!item) {
					return null
				}
				const { position, ...rest } = item
				return { value: { ...rest }, position }
			})
			printerVals.parameters.printer.locations = newLocationArr
		}
		updateItem(printerVals)
	}

	if(!locationData.length) {
		return t('common.strings.table_no_data')
	}

	const separateKitchenBillModeOptions = [
		{ label: t('options_section.strings.kitchen_bill_split_article'), value: 1 },
		{ label: t('options_section.strings.kitchen_bill_split_course'), value: 2 }
	]

	return(
		<Form
			smartSubmit
			initialValues={formData}
			onSubmit={handleSubmit}
			className={globalStyles['flex-cols']}
		>
			<Checkbox field='parameters.printer.isKitchenPrinterActive' label={t('options_section.fields.isKitchenPrinterActive')}/>
			<Checkbox field='parameters.printer.isPrintKitchenBillAfterCompletionOnly' label={t('options_section.fields.isPrintKitchenBillAfterCompletionOnly')}/>
			<Checkbox field='parameters.printer.isPrintKitchenBillForTableOnly' label={t('options_section.fields.isPrintKitchenBillForTableOnly')}/>
			<div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
				<Checkbox field='parameters.printer.separateKitchenBill' label={t('options_section.strings.separate_kitchen_bill')} />
				{formData?.parameters?.printer?.separateKitchenBill ? (
					<div style={{ width: 125, marginTop: -3 }}>
						<Select
							field='parameters.printer.separateKitchenCourse'
							options={separateKitchenBillModeOptions}
							inline
							shrink
							isCompact
						/>
					</div>
				) : (
					<span style={{ display: 'none' }} />
				)}
			</div>
			<Checkbox field='parameters.showPriceOnKitchenBill' label={t('options_section.strings.showPriceOnKitchenBill')}/>
			<Checkbox field='parameters.printer.printCoursePositions' label={t('options_section.fields.printCoursePositions')}/>
			<NumberInput field='parameters.printer.topMargin' label={t('options_section.strings.top_margin')} shrink/>
			<h4>{t('options_section.strings.kitchen_locations')}</h4>
			<Divider height={20}/>
			{locationData.map((printer) => (
				<PrinterRecord key={printer.dbIndex} printer={printer} designProject={data.parameters?.designProject} kitchenMasterClientId={data.shop?.kitchenMasterClientId} isMasterPrintActivated={appData.isMasterPrintActivated} gruberConfig={data.shop?.gruberConfig || []} />
			))}
		</Form>
	)
}

export default PrinterLocation
